import {Component} from '@angular/core';

import {VoiceService} from '../../services/voice/voice.service';
import {WordPlayBtnComponent} from './word-play-btn.component';
import {GlobalEventService} from "../../services/global-event/global-event.service";

@Component({
  selector: 'app-dialect-word-play-btn',
  template: `
    <div *ngIf="word && word.wordVoice"
         class="option-box">
      <button type="button"
              class="option-btn type-1"
              (click)="playSound($event)">

        <i class="ic ic-listen {{ on ? 'on' : '' }}"></i>
      </button>
    </div>
  `,
  styleUrls: ['./dialect-word-play-btn.component.scss'],
  host: { class: 'item-option-box' },
})
export class DialectWordPlayBtnComponent extends WordPlayBtnComponent {

  constructor(
    protected override voice: VoiceService,
    protected override globalEventSvc: GlobalEventService,
  ) {
    super(voice, globalEventSvc);
  }

}
